export default {
  // indexable guest pages
  home: {
    url: '/',
    title: 'A better knowledge sharing experience over video',
    description: 'Teach, consult, mentor, learn, schedule meetings and change the world with Kintell – the simple and powerful way to share knowledge over video.',
    index: true,
    meta (head) {
      // add any extra meta
      const orgSchema = {
        hid: 'org-schema',
        type: 'application/ld+json',
        innerHTML: `{
                "@context": "https://schema.org",
                "@type": "Corporation",
                "name": "Kintell",
                "description": "Teach, consult, mentor, learn, schedule meetings and change the world with Kintell – the simple and powerful way to share knowledge over video.",
                "url": "https://kintell.com/",
                "logo": "https://kintell.com/images/kintell-logo.svg",
                "sameAs": [
                  "https://www.linkedin.com/company/kintell-com/",
                  "https://www.youtube.com/channel/UCEbUiHCmaZaJq-y_Nq_zPhw",
                  "https://www.instagram.com/kintell_official/",
                  "https://www.crunchbase.com/organization/kintell"
                ]
              }`,
      }
      const websiteSchema = {
        hid: 'website-schema',
        type: 'application/ld+json',
        innerHTML: `{
               "@context": "http://schema.org/",
               "@type":"WebSite",
               "url":"https://kintell.com/",
               "potentialAction" :{
                   "@type":"SearchAction",
                   "target":"https://kintell.com/search/?query={search_term_string}",
                   "query-input":"required name=search_term_string"
                 }
               }`
      }
      const siteNavSchema = {
        hid: 'site-nav-schema',
        type: 'application/ld+json',
        innerHTML: `{
                "@context":"http://schema.org",
                "@type":"ItemList",
                "itemListElement":[
                  {
                    "@type": "SiteNavigationElement",
                    "position": 1,
                    "name": "FAQs",
                    "description": "Your Kintell questions answered.",
                    "url":"https://kintell.com/faq"
                  },
                  {
                    "@type": "SiteNavigationElement",
                    "position": 2,
                    "name": "Articles",
                    "description": "Read articles from our amazing advisors",
                    "url":"https://kintell.com/articles"
                  },
                  {
                    "@type": "SiteNavigationElement",
                    "position": 3,
                    "name": "Find An Advisor",
                    "description": "Search advisors",
                    "url":"https://kintell.com/search"
                  },
                  {
                    "@type": "SiteNavigationElement",
                    "position": 4,
                    "name": "Contact Us",
                    "description": "Contact us for any queries",
                    "url":"https://kintell.com/get-in-touch"
                  }
                ]
              }`
      }

      head.script.push(orgSchema)
      head.script.push(siteNavSchema)
      head.script.push(websiteSchema)
      return head
    }
  },
  featureVideo: {
    url: '/features/video-meetings',
    title: 'Video meetings',
    metaTitle: 'In-browser video chat and meetings',
    description: 'Host your next video meeting with Kintell. All in browser, free cloud recording, and with no time limit. How’s that for gold?',
    image: 'https://assets.kintell.com/social/video-og.png',
  },
  featureVideoOld: {
    url: '/f/video-chat',
    noindex: true
  },
  featureCalendar: {
    url: '/features/calendar-and-bookings',
    title: 'Calendar & bookings',
    metaTitle: 'Integrated calendar and meeting scheduling',
    description: 'Take advantage of Kintell’s integrated calendar and scheduling features to effortlessly plan your next video session.',
    image: 'https://assets.kintell.com/social/calendar-og.png',
  },
  featureCalendarOld: {
    url: '/f/cal',
    noindex: true
  },
  featureCards: {
    url: '/features/kintell-cards',
    title: 'Kintell Cards',
    metaTitle: 'How to use your Cards',
    description: 'Offer your time for free, or for a fee, and get booked for your expertise with Kintell Cards – the better way to define how you want your time utilised.',
    image: 'https://assets.kintell.com/social/kintell-cards-og.png'
  },
  featuredCardsOld: {
    url: '/f/k-cards',
    noindex: true
  },
  featurePay: {
    url: '/features/payment-integration',
    title: 'Payment integration',
    description: 'Get paid for your consultations or coaching and rewarded for your expertise with Kintell’s payment integration.',
    image: 'https://assets.kintell.com/social/payment-og.png'
  },
  featurePayOld: {
    url: '/f/pay',
    noindex: true
  },
  knowledgeMarketplace: {
    url: '/search',
    title: 'Knowledge Marketplace',
    metaTitle: 'On-demand insights from vetted experts',
    description: 'Find your next mentor or brain to pick by searching the Kintell Marketplace, where you’ll find experts on everything from digital marketing to mental health and more.',
    image: 'https://assets.kintell.com/social/market-og.png',
  },
  forBusiness: {
    url: '/for-business',
    title: 'For Business',
    metaTitle: 'The modern way to connect over video',
    description: 'Lead your industry and empower your people to connect and support each other with Kintell’s turnkey video solution.',
    image: 'https://assets.kintell.com/social/business-og.png',
  },
  forBusinessOld: {
    url: '/kb',
    noindex: true
  },
  giftcards: {
    url: '/giftcards',
    title: 'Kintell Gift cards',
    metaTitle: 'Share the love with Kintell Gift Cards',
    description: 'The only thing better than getting is giving – so give the gift of knowledge and insight with Kintell Gift Cards.',
    image: 'https://assets.kintell.com/social/giftcards-og.png',
    index: true,
  },
  pricing: {
    url: '/pricing',
    title: 'Pricing',
    description: 'Whether you’re starting out, or ready to up your impact and reach a wider audience, here’s what’s in store for Kintell Basic, Kintell Plus and Kintell Pro.',
    image: 'https://assets.kintell.com/social/pricing-og.png',
    index: true,
  },

  // round up pages
  digitalMarketing: {
    url: '/digital-marketing',
    title: 'Demystify digital marketing',
    description: 'We\'ve rounded up 10 of the best digital marketing advisors who can help you with Google Ads (PPC), Anaytics, Facebook Ads, content marketing, SEO and more.',
    image: '~images/roundup/coaches-full.jpeg',
    index: true,
  },
  health: {
    url: '/health',
    title: 'Power-up your diet',
    description: 'Get practical guidance on everything from boosting your natural energy levels to fitting good nutrition into a busy lifestyle.',
    image: '~images/roundup/health-full.jpeg',
    index: true,
  },
  mentalHealth: {
    url: '/mental-health',
    title: 'Prioritise your mental health',
    description: 'Nothing is more important than your mental health, so check out our roundup of the best counsellors, psychotherapists and meditation advisors on Kintell.',
    image: 'https://images.ctfassets.net/0n6k7bbqdbo7/77z1Q7252QWwtwAy90AEOM/471226371d522c93c9cc0272097f4478/image_15.png?h=333',
    index: true,
  },
  facilitatePublicSpeaking: {
    url: '/facilitate-public-speaking',
    title: 'Facilitate With Confidence',
    description: 'Whether you’re prepping for a presentation, planning a speech, or looking for tips on running workshops, we’ve got an advisor who can help.',
    image: '~images/roundup/facilitate-public-speaking-full.png',
    index: true,
  },
  homeLiving: {
    url: '/home-living',
    title: 'Make your house a home',
    description: 'We\'ve rounded up a supergroup of advisors that can help you create your dream home, from decluttering to creating a colour scheme.',
    image: '~images/roundup/home-full.jpeg',
    index: true,
  },
  greenConsciousness: {
    url: '/green-consciousness',
    title: 'Become a sustainable business',
    description: 'We\'ve rounded a collection of industry-leading advisors to help you create sustainable, environmentally-conscious, energy efficient business practices.',
    image: '~images/roundup/green-consciousness-full.png',
    index: true,
  },
  careerCoach: {
    url: '/career-coach',
    title: 'Transform your career',
    description: 'We round up 6 of the best Kintell career coaches, who can help you switch careers, optimise your social presence, polish your CV, or build a personal brand.',
    image: '~images/roundup/career-full.png',
    index: true,
  },
  coaches: {
    url: '/coaches',
    title: 'Reach peak performance',
    description: 'We have a range of amazing coaches to help you be the best you can be, in everything from communication techniques to effective leadership.',
    image: '~images/roundup/coaches-full.jpeg',
    index: true,
  },
  startup: {
    url: '/startup',
    title: 'Accelerate your startup',
    description: 'Tap in to a world of knowledge on starting, funding, growing, marketing, and leading your own business, with insights from our experienced startup advisors.',
    image: '~images/roundup/startup-full.jpeg',
    index: true,
  },
  personalFinance: {
    url: '/personal-finance',
    title: 'Marie Kondo your finances',
    description: 'Declutter your approach to money, with guidance on how to invest in shares, making budgets, and planning your own finances.',
    image: '~images/roundup/personal-finance-full.png',
    index: true,
  },
  buildWebsite: {
    url: '/build-website',
    title: 'Build your own website',
    description: 'There are a lot of tools out there to simply create a beautiful website, but if you\'ve never worked in the digital space it might be hard to know where to start.',
    image: '~images/roundup/build-website-full.png',
    index: true,
  },
  learnToCode: {
    url: '/learn-to-code',
    title: 'Learn to code',
    description: 'We’ve gathered some of our top advisors, with an array of knowledge in coding for different purposes and languages, so that you can get a head-start on your coding journey.',
    image: '~images/roundup/learn-to-code-full.png',
    index: true,
  },
  personalBrand: {
    url: '/personal-brand',
    title: 'Sharpen your personal brand',
    description: 'We’ve gathered some of our top personal branding advisors to help you leverage your creative skills and refine the way you present yourself online and in person.',
    image: '~images/roundup/personal-brand-full.png',
    index: true,
  },
  search: {
    url: '/search',
    title: 'Kintell advisors',
    metaTitle: 'On-demand insights from vetted experts',
    description: 'Find your next mentor or brain to pick by searching the Kintell Marketplace, where you’ll find experts on everything from digital marketing to mental health and more.',
    image: 'https://assets.kintell.com/social/market-og.png',
    index: true,
  },
  login: {
    url: '/sign-in',
    title: 'Log in',
    description: 'Log in to Kintell here, and start scheduling one-to-one and multi-party video sessions, mentoring and learning, and accelerating your impact.',
    index: true,
  },
  faqs: {
    url: '/faq',
    title: 'FAQs',
    metaTitle: 'Frequently asked questions',
    description: 'Got a burning question about Kintell? You might just find the answer here – and learn how to best use Kintell to change the world.',
    image: 'https://assets.kintell.com/social/fag-og.png',
    index: true,
    meta (head) {
      head.script.push({
        hid: 'faq-schema',
        type: 'application/ld+json',
        innerHTML: '{ "@context": "https://schema.org", "@type": "FAQPage", "mainEntity": [{ "@type": "Question", "name": "Can anyone sign up to Kintell?", "acceptedAnswer": { "@type": "Answer", "text": "Yup! It\'s free and silly easy to join Kintell. All it takes is a few details (here) and you’ll be learning from our Advisors in no time. If you’ve got the knowledge and a yearning to become an Advisor yourself, you need to create a Kintell Card (see Becoming an Advisor)." } },{ "@type": "Question", "name": "How much does it cost to sign up to Kintell?", "acceptedAnswer": { "@type": "Answer", "text": "Like all the best things in life, signing up to Kintell is free! You\'ll only need to pay when you book an Advisor for a Kintell session." } },{ "@type": "Question", "name": "What details do I need to provide when signing up?", "acceptedAnswer": { "@type": "Answer", "text": "We need your real name (so we know what to call you), your email (so we can get in touch) and your mobile number (so we can send you alerts). That\'s it! Or, if you’ve got a LinkedIn profile, you can sign up using that, too. Easy peasy." } },{ "@type": "Question", "name": "Can I include my title in my name?", "acceptedAnswer": { "@type": "Answer", "text": "Kintell’s a community that’s all about merit and egalitarian knowledge sharing. So if you want to let people know about your formal education or any relevant certificates you’ve collected along the way, then you can include that in your Kintell Card description or as a skill" } },{ "@type": "Question", "name": "Can I integrate my calendar with Kintell?", "acceptedAnswer": { "@type": "Answer", "text": "But of course! Google, Outlook and any other digital calendar are easily synced. Plus we’ll block out those entries in your Kintell calendar, so you can be sure you won’t get double-booked." } },{ "@type": "Question", "name": "What countries are supported internationally?", "acceptedAnswer": { "@type": "Answer", "text": "Anyone in the world – yes, anyone – with a valid credit/debit card can make a booking with advisors from Australia, New Zealand, the UK, Sweden and Denmark. We\'re working around the clock to support more countries, but for now, Advisors from other countries can only take free bookings." } },{ "@type": "Question", "name": "Do I need to be signed up to Kintell to make a booking?", "acceptedAnswer": { "@type": "Answer", "text": "We want to make sure that Advisors only receive valid booking requests from actual real people and not three dogs in an overcoat, so you\'ll have to sign up to Kintell when making a booking. Luckily it’s as easy as 1-2-3!" } },{ "@type": "Question", "name": "Do I need any special equipment?", "acceptedAnswer": { "@type": "Answer", "text": "All of our Kintell video sessions are held on Kintell.com, or via the iPhone Kintell Companion App (available at the App Store), and you can use any device you like. If you’re using your laptop or desktop computer, you just need to be sure you can use your camera and microphone (pretty important if you’re doing a video chat, I reckon!). We recommend throwing on your headphones to block out surrounding noises :)" } },{ "@type": "Question", "name": "What browser or operating system works best with Kintell?", "acceptedAnswer": { "@type": "Answer", "text": "Google Chrome – whatever the latest version is – installed on Mac or Windows. Other browsers work as well, but Chrome is the most stable and is going to give you the best Kintell experience." } }] }'
      })
      return head
    }
  },
  getInTouch: {
    url: '/get-in-touch',
    title: 'Contact Us',
    description: 'We’d love to hear from you – so if you’ve got an inquiry, need customer support or a demo, or just want to tell us what you’re thinking, then you’re in the right place.',
    index: true,
  },
  codeOfConduct: {
    url: '/code-of-conduct',
    title: 'Code of Conduct',
    description: 'Kintell was created to empower people from all walks of life, so maintaining an inclusive, transparent, and trustworthy community is key.',
    index: true,
  },
  cancellationPolicy: {
    url: '/cancellation-policy',
    title: 'Cancellation Policy',
    index: true,
  },
  articles: {
    url: '/articles',
    title: 'Articles',
    description: 'Some of Kintell’s brightest advisors share their insights on how they’re making knowledge more accessible.',
    image: 'https://assets.kintell.com/social/videos-og.png',
    index: true,
  },
  useCases: {
    url: '/articles/category/use-cases',
    title: 'Use Cases',
    description: 'Discover how professionals, industry leaders and organisations are using Kintell to change the world.',
    image: 'https://assets.kintell.com/social/use-cases-og.png',
    index: true,
  },
  videos: {
    url: '/videos',
    title: 'Kintell Video Channel',
    description: 'We\'ve collected video highlights from our subject specialists, industry champions and other Kintell advisors on a journey to deeper understanding.',
    image: 'https://assets.kintell.com/social/videos-og.png',
    index: true,
  },
  joinNow: {
    url: '/join-now',
    title: 'Sign up',
    description: 'Kintell’s better when you’re part of the conversation. Sign up for Kintell in just 60 seconds, and start consulting, learning and meeting on your terms.',
    index: true,
  },
  // no indexable guest pages
  privacy: {
    url: '/privacy',
    title: 'Privacy Policy',
  },
  termsAndConditions: {
    url: '/terms-and-conditions',
    title: 'Terms & Conditions',
  },
  notInterested: {
    // when someone clicks "not interested" on the email invite
    url: '/not-interested',
    title: 'Unsubscribe',
  },
  forgotPassword: {
    url: '/forgot-password',
    title: 'Forgot Password',
  },
  resetPassword: {
    url: '/reset-password',
    title: 'Reset Password',
  },
  embed: {
    url: '/embed',
    title: 'Kintell Cards',
  },
  welcome: {
    url: '/welcome',
    title: 'Welcome to Kintell',
  },

  myGroups: {
    url: '/g',
    title: 'My Groups',
    description: '',
  },

  // authenticated
  dashboard: {
    url: '/my-kintell/dashboard',
    title: 'Overview',
    metaTitle: 'The Swiss Army knife of video knowledge sharing',
    description: 'Whether you want to quickly start a video chat without time limits, or need somewhere to take paid video consultation bookings, Kintell has you covered.',
  },
  bookings: {
    url: '/my-kintell/bookings',
    title: 'Confirmed Bookings'
  },
  bookingRequests: {
    url: '/my-kintell/bookings/requests',
    title: 'Booking Requests'
  },
  personalDetails: {
    url: '/my-kintell/my-details',
    title: 'My Profile'
  },
  advisorSettings: {
    url: '/my-kintell/my-details/advisor-settings',
    title: 'Advisor Settings'
  },
  billing: {
    url: '/my-kintell/my-details/billing',
    title: 'Billing'
  },
  myKintellCards: {
    url: '/my-kintell/kintell-cards',
    title: 'My Cards'
  },
  createKintellCard: {
    url: '/my-kintell/kintell-cards/create',
    title: 'Create Kintell Card'
  },
  myRewards: {
    url: '/my-kintell/more',
    title: 'Invites & Rewards'
  },
  favourites: {
    url: '/my-kintell/more/favourites',
    title: 'Favourites'
  },
  credits: {
    url: '/my-kintell/more/credits',
    title: 'Credits'
  },
  calendar: {
    url: '/my-kintell/my-calendar',
    title: 'My Calendar'
  },
  syncSettings: {
    url: '/my-kintell/my-calendar/sync-settings',
    title: 'Sync Settings'
  },
  workingHours: {
    url: '/my-kintell/my-calendar/working-hours',
    title: 'Working Hours'
  },
  bookingArchive: {
    url: '/my-kintell/bookings/archive',
    title: 'Booking Archive'
  },
  initiateABooking: {
    url: '/my-kintell/bookings/initiate',
    title: 'Initiate a Booking'
  },
  instantBooking: {
    url: '/my-kintell/bookings/instant',
    title: 'Instant Booking'
  },
  groupAdmin: {
    url: '/my-kintell/my-group',
    title: 'Group Admin'
  },
  facilitateBooking: {
    url: '/my-kintell/my-groups/facilitate-booking',
    title: 'Facilitate a Booking'
  },
  signOut: {
    url: '/sign-out',
    title: 'Log out'
  },
}
